import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import EventEntries from "./EventEntries";

createRoot(document.getElementById("tmt-event-entries")).render(
  <StrictMode>
    <EventEntries />
  </StrictMode>
);
